import { Modal } from "./modal"

export interface SessionExpiredNoticeProps {
}

// eslint-disable-next-line no-empty-pattern -- not important to fix
export default function SessionExpiredNotice({}: SessionExpiredNoticeProps) {
  return (
    <Modal
      title={"Your Session Has Expired"}
      footer={
        <a
          className="btn btn-primary btn--multi-line"
          style={{width: "100%"}}
          role="button"
          onClick={() => window.location.reload()}
        >
          <strong className="block">Click here to refresh page.</strong>
          <span className="block">You must refresh the page to continue.</span>
        </a>
      }
    />
  )
}
